import { FileBarChart } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/shared/components/empty-state';

/**
 * A report with nothing in it. Filtered-empty (channel, provider, brand or
 * denomination set) offers to clear them; otherwise it suggests a wider scope.
 */
export function ReportNoData({
  filtered,
  onClear,
  title = 'No data for these filters',
}: {
  filtered: boolean;
  onClear: () => void;
  title?: string;
}) {
  return (
    <EmptyState
      icon={FileBarChart}
      title={title}
      description={
        filtered
          ? 'No order in the period matches the payment channel, provider, brand or denomination chosen.'
          : 'Try a longer period, another country, or all your countries.'
      }
      action={
        filtered ? (
          <Button variant="outline" size="sm" onClick={onClear}>
            Clear filters
          </Button>
        ) : undefined
      }
    />
  );
}
